import { BACKGROUND_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/background/questionnaireAnswer'
import { HISTORY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/history/questionnaireAnswer'
import { IMMUNIZATIONS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/immunizations/questionnaireAnswer'
import { RISK_ASSESSMENT_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/risk-assessment/questionnaireAnswer'
import { NEUROLOGICAL_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/neurological/questionnaireAnswer'
import { COGNITIVE_PSYCHOSOCIAL_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/cognitive-psychosocial/questionnaireAnswer'
import { MUSCULOSKELETAL_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/musculoskeletal/questionnaireAnswer'
import { LINES_DRAINS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/lines-drains/questionnaireAnswer'
import { THERAPIES_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/therapies/questionnaireAnswer'
import { SENSORY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/sensory/questionnaireAnswer'
import { PAIN_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/pain/questionnaireAnswer'
import { CARDIAC_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/cardiac/questionnaireAnswer'
import { RESPIRATORY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/respiratory/questionnaireAnswer'
import { ENDOCRINE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/endocrine/questionnaireAnswer'
import { GASTROINTESTINAL_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/gastrointestinal/questionnaireAnswer'
import { INTEGUMENTARY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/integumentary/questionnaireAnswer'
import { PHYSICIAN_NOTIFICATION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/physician-notification/questionnaireAnswer'
import { VITALS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from './subsections/vitals/questionnaireAnswer'

// Amalgamate all subsection questionnaire answer type mappings
export const MEDICAL_BACKGROUND_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  ...BACKGROUND_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...HISTORY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...IMMUNIZATIONS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...RISK_ASSESSMENT_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...NEUROLOGICAL_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...COGNITIVE_PSYCHOSOCIAL_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...MUSCULOSKELETAL_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...LINES_DRAINS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...THERAPIES_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...SENSORY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...PAIN_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...CARDIAC_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...RESPIRATORY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...ENDOCRINE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...GASTROINTESTINAL_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...INTEGUMENTARY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...PHYSICIAN_NOTIFICATION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...VITALS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE
}
